import React, { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { api } from "../lib/api";

const ease = [0.22, 1, 0.36, 1];

const CountUp = ({ target }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [forced, setForced] = useState(false);
  const [n, setN] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setForced(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const go = inView || forced;

  useEffect(() => {
    if (!go) return;
    if (target <= 0) { setN(0); return; }
    const duration = 1600;
    const start = performance.now();
    let raf;
    const tick = (now) => {
      const p = Math.min((now - start) / duration, 1);
      setN(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [go, target]);

  return <span ref={ref}>{n.toLocaleString()}</span>;
};

export const FightFundCounter = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/stats/fight-fund").then((r) => setStats(r.data)).catch(() => setStats({ pieces_sold: 0, orders: 0 }));
  }, []);

  if (stats === null) return null;

  return (
    <section data-testid="fight-fund" className="bg-[#0B0E14] text-[#EDEEF1]">
      <div className="w-full mx-auto px-4 sm:px-8 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
        <div className="md:col-span-7">
          <p className="label text-[#2B6BFF] mb-6">// The Movement</p>
          <p className="font-serif-display text-7xl sm:text-8xl md:text-9xl leading-none tracking-tight" data-testid="fight-fund-count">
            <CountUp target={stats.pieces_sold} />
          </p>
          <p className="label mt-4 tracking-[0.3em]">Pieces sold for Garrison</p>
        </div>
        <div className="md:col-span-5">
          <motion.p
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.9, ease }}
            className="text-lg md:text-xl text-[#B8BCC4] leading-relaxed"
          >
            {stats.pieces_sold > 0
              ? "Every piece on this counter is someone standing with Garrison. His fight. Our fight — and it's growing."
              : "The count starts now. Every piece you pick up puts your name in Garrison's corner. His fight. Our fight."}
          </motion.p>
          <p className="label text-[#8A8F99] mt-6" data-testid="fight-fund-orders">
            {stats.orders.toLocaleString()} order{stats.orders === 1 ? "" : "s"} and counting
          </p>
        </div>
      </div>
    </section>
  );
};
